import e from"styled-components";const t=e.div`
	display: flex;
	padding: 8px;
	flex-direction: column;
	align-items: flex-start;
	gap: ${({isTemplate:e})=>e?"8px":"12px"};

	align-self: stretch;
`,i=e.div`
	color: ${({theme:e})=>e.text.title};
	font-family: 'SF Pro Display';
	font-size: ${({isTemplate:e})=>e?"11px":"22px"};
	font-style: normal;
	font-weight: 500;
	line-height: ${({isTemplate:e})=>e?"12.176px":"25.887px"};

	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
	overflow: hidden;
	text-overflow: ellipsis;
`,l=e.div`
	display: flex;
	flex-flow: row;
	align-items: center;
	gap: 4px;
	align-self: stretch;
	color: ${({theme:e})=>e.text.gray};
	font-family: 'SF Pro Display';
	font-size: ${({isTemplate:e})=>e?"8px":"13px"};
	font-style: normal;
	font-weight: 500;
`;e.div`
	color: ${({theme:e})=>e.text.text};
	font-family: 'SF Pro Display';
	font-size: ${({isTemplate:e})=>e?"8px":"13px"};
	font-style: normal;
	font-weight: 500;
	line-height: ${({isTemplate:e})=>e?"8px":"19px"};
`;export{t as CardContent,l as SpaceAndAuthor,i as Title};
